import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {Router} from '@angular/router';

import {StaticPathUtil} from '@app/core/util/static-path.util';
import {ListEntry} from '@app/shared/list/list.component';
import {Kontakt} from '@pezi/entities';
import { NgIf, NgClass } from '@angular/common';
import { PeziButtonComponent } from '../../pezi-button/pezi-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ContactSearchComponent } from '../../contact-search/contact-search.component';
import { ContactDetailComponent } from '../../contact-detail/contact-detail.component';

@Component({
  selector: 'app-kontakt-dialog',
  templateUrl: './contact-search-dialog.component.html',
  styleUrls:  ['./contact-search-dialog.component.scss'],
  standalone: true,
  imports:    [
    NgIf,
    MatDialogTitle,
    PeziButtonComponent,
    CdkScrollable,
    MatDialogContent,
    NgClass,
    ContactSearchComponent,
    ContactDetailComponent,
    MatDialogActions,
    MatDialogClose
  ]
})
export class ContactSearchDialogComponent {

  public selectedContact: ListEntry<Kontakt>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: boolean, public staticPath: StaticPathUtil,
              private dialogRef: MatDialogRef<ContactSearchDialogComponent>, private router: Router) {
  }

  public selectContact(contact: ListEntry<Kontakt>): void {
    this.selectedContact = contact;
  }

  public removeSelection(): void {
    this.selectedContact = null;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

}
